import React, { useState, useEffect } from 'react'
import { Trash, X } from '@phosphor-icons/react'

const ModalEditProjectPublicView = ({ open, onClose, onUpdate, project }) => {
  const [formData, setFormData] = useState({
    card_color: project?.card_color || 'primary',
    button_color: project?.button_color || 'error',
    button_text: project?.button_text || 'please submit',
    text_area_placeholder: project?.text_area_placeholder || 'this is amazing'
  })

  useEffect(() => {
    if (project) {
      setFormData({
        card_color: project.card_color || 'primary',
        button_color: project.button_color || 'error',
        button_text: project.button_text || 'please submit',
        text_area_placeholder: project.text_area_placeholder || 'this is amazing'
      })
    }
  }, [project])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = () => {
    onUpdate(formData)
    onClose()
  }

  const colorOptions = [
    'primary', 'secondary', 'accent', 'info', 'success', 
    'warning', 'error', 'neutral'
  ]

  return (
    <div>
      <dialog className={`modal ${open ? 'modal-open' : ''}`}>
        <div className="modal-box">
          <h3 className="font-bold text-lg">Edit Project Public View</h3>
          
          <div className="form-control w-full mt-4">
            <label className="label">
              <span className="label-text">Card Color</span>
            </label>
            <select 
              className="select select-bordered w-full" 
              name="card_color"
              value={formData.card_color}
              onChange={handleChange}
            >
              <option value="">Select card color</option>
              {colorOptions.map(color => (
                <option key={color} value={color}>{color}</option>
              ))}
            </select>
            <div className={`mt-2 p-2 bg-${formData.card_color} rounded text-${formData.card_color}-content`}>
              Preview of {formData.card_color} card
            </div>
          </div>

          <div className="form-control w-full mt-4">
            <label className="label">
              <span className="label-text">Button Color</span>
            </label>
            <select 
              className="select select-bordered w-full" 
              name="button_color"
              value={formData.button_color}
              onChange={handleChange}
            >
              <option value="">Select button color</option>
              {colorOptions.map(color => (
                <option key={color} value={color}>{color}</option>
              ))}
            </select>
            <button className={`btn btn-${formData.button_color} mt-2`}>
              {formData.button_text || "Preview"}
            </button>
          </div>

          <div className="form-control w-full mt-4">
            <label className="label">
              <span className="label-text">Button Text</span>
            </label>
            <input 
              type="text" 
              className="input input-bordered w-full" 
              name="button_text"
              value={formData.button_text}
              onChange={handleChange}
              placeholder="Enter button text"
            />
          </div>

          <div className="form-control w-full mt-4">
            <label className="label">
              <span className="label-text">Text Area Placeholder</span>
            </label>
            <input 
              type="text" 
              className="input input-bordered w-full" 
              name="text_area_placeholder"
              value={formData.text_area_placeholder}
              onChange={handleChange}
              placeholder="Enter text area placeholder"
            />
            <textarea 
              className="textarea textarea-bordered mt-2" 
              placeholder={formData.text_area_placeholder}
              disabled
            ></textarea>
          </div>

          <div className="modal-action">
            <button className="btn btn-outline btn-sm" onClick={onClose}>
              <span className="mr-2">Cancel</span>
              <X size={16}/>
            </button>
            <button 
              className="btn btn-primary btn-sm"
              onClick={handleSubmit}
            >
              <span className="mr-2">Save Changes</span>
            </button>
          </div>
        </div>
        <form method="dialog" className="modal-backdrop" onClick={onClose}>
          <button>close</button>
        </form>
      </dialog>
    </div>
  )
}

export default ModalEditProjectPublicView